module.exports = __webpack_public_path__ + "img/OSINT Job Ad.35b9ec86.png";